import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, Brain } from "lucide-react";
import { ExecutiveAICommandCenter } from "@/components/admin/ExecutiveAICommandCenter";
import { SuperAdminPinGate } from "@/components/admin/SuperAdminPinGate";
import { requireSuperAdminGuard } from "@/lib/security/tenantIsolation";

export const Route = createFileRoute("/admin/executive-ai-command-center")({
  beforeLoad: ({ location }) => { requireSuperAdminGuard(location.pathname); },
  head: () => ({
    meta: [
      { title: "Executive AI Command Center · VerseSport™" },
      { name: "description", content: "Business, User, Attention, Growth, Monetization & Operational Intelligence." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <SuperAdminPinGate>
      <div className="min-h-screen bg-background text-foreground">
        <header className="sticky top-0 z-30 border-b border-border/60 glass">
          <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 md:px-6">
            <Link to="/admin" className="flex h-9 w-9 items-center justify-center rounded-lg glass hover:bg-accent" aria-label="Back">
              <ArrowLeft className="h-4 w-4" />
            </Link>
            <div className="flex items-center gap-2">
              <Brain className="h-4 w-4 text-primary" />
              <div>
                <h1 className="text-sm font-black tracking-tight">Executive AI Command Center</h1>
                <div className="text-[10px] font-bold text-gradient-red tracking-widest">BUSINESS · USERS · ATTENTION · GROWTH · MONETIZATION</div>
              </div>
            </div>
          </div>
        </header>
        <main className="mx-auto max-w-7xl px-4 py-6 md:px-6">
          <ExecutiveAICommandCenter />
        </main>
      </div>
    </SuperAdminPinGate>
  ),
});